import superagent from 'superagent';
import { backendUrl } from '@helpers/consts';




export async function fetchRegionConfigs() {
  try {
    const response = await superagent.get(`${backendUrl}/regionConfigs`).set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`);
    return response.body;
  } catch (error) {
    console.log("Failed to fetch region configs", error)
  }
}


export async function fetchRegionConfigDetails(regionId) {
  try {
    const response = await superagent.get(`${backendUrl}/regionConfigs/${regionId}`).set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`);
    return response.body;
  } catch (error) {
    console.log("Failed to fetch region config details", error)
  }
}


export async function createRegionConfig(data) {
  try {
    const response = await superagent
      .post(`${backendUrl}/regionConfigs`)
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('Content-Type', 'application/json')
      .send(data);
    
    return response.body;
  } catch (error) {
    console.log("Failed to create region config", error)
  }
}


export async function fetchAvailableOrderSources(
  queryData
) {
  try {
    

    const response = await superagent.get(`${backendUrl}/orderSourceMappings?type=${queryData.type}`)
    .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`);
    return response.body;
  } catch (error) {
    console.log("Failed to fetch available order sources", error)
  }
}


export async function addOrderSourceToRegion(regionId, orderSourceData) {
  try {
    const response = await superagent
      .post(`${backendUrl}/regionConfigs/${regionId}/orderSources`)
      .set('Content-Type', 'application/json')
      .send(orderSourceData)
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`);
    
    return response.body;
  } catch (error) {
    console.log("Failed to add order source to region", error)
  }
}


export async function removeOrderSource(regionId, orderSourceId) {
  try {
    await superagent.delete(`${backendUrl}/regionConfigs/${regionId}/orderSources/${orderSourceId}`).set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)  ;
    return true;
  } catch (error) {
    console.log("Failed to remove order source from region", error)
  }
}

export async function updateRegionConfig(regionId, data) {
  try {
    const response = await superagent
      .put(`${backendUrl}/regionConfigs/${regionId}`)
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('Content-Type', 'application/json')
      .send(data);
    
    return response.body;
  } catch (error) {
    console.log("Failed to update region config", error)
    throw error;
  }
}
